import React from 'react';
import { useSelector } from 'react-redux';

import { messages } from './messages';
import OrderNumberLink from '../../../components/order-number-link';
import Global from '../../../store/global-selectors';

const OrderNumberColumn = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  if (!ret || !ret.orderNumber) {
    return '';
  }

  return (
    <OrderNumberLink
      id={ret.fulfillmentPlanId}
      orderNumber={ret.orderNumber}
      returnFulfillmentId={fulfillmentId}
      salesOrderAssignedUserId={ret.salesOrderAssignedUser}
      salesOrderId={ret.salesOrderId}
      storeGuid={ret.storeGuid}
    />
  );
};

export const OrderNumber = {
  getMessageDescriptor: () => messages.orderNumber,
  id: 'order-number',

  render: ({ fulfillmentId }) => {
    return <OrderNumberColumn fulfillmentId={fulfillmentId} />;
  },
};
